interface Window {
    // eslint-disable-next-line
    doScan(success: (blob: Blob) => void, error: (message: string) => void): void
}
declare const window: Window

/**
 * スキャナサービス
 */
export default class ScanerService {
    /** インスタンス */
    private static _instance: ScanerService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new ScanerService();
        }
        return this._instance;
    }

    
    /**
     * スキャン
     * @param success
     * @param error 
     */
    // eslint-disable-next-line
    public scan(success: (blob: Blob) => void, error: (message: string) => void) {
        if (typeof window.doScan == "function") {
            window.doScan(success, error)
        } else {
            error("fi Series WebAPIが起動していません。")
        }
    }

}
